import SEO from "../components/SEO";
import Hero from "../components/Hero";
import WhyChooseUs from "../components/WhyChooseUs";
import Services from "../components/Services";
import "../styles/Home.css";

export default function Home() {
  return (
    <>
      {/* =====================================================
          HOMEPAGE SEO
      ====================================================== */}

      <SEO
        title="Bike & Scooty Rental in Udaipur | VK Bike On Rent"
        description="Rent bikes, scooters and taxis in Udaipur with VK Bike On Rent. Explore Udaipur with convenient rental options, WhatsApp booking and local travel services."
        canonical="https://vkbikeonrent.in/"
      />

      {/* =====================================================
          HOMEPAGE
      ====================================================== */}

      <main className="home-page">

        {/* =================================================
            HERO
        ================================================== */}

        <section aria-labelledby="hero-main-title">
          <Hero />
        </section>

        {/* =================================================
            WHY CHOOSE US
        ================================================== */}

        <section
          aria-labelledby="why-title"
          className="home-section"
        >
          <WhyChooseUs />
        </section>

        {/* =================================================
            SERVICES
        ================================================== */}

        <section
          aria-labelledby="services-title"
          className="home-section"
        >
          <Services />
        </section>

        {/* =================================================
            LOCAL BUSINESS INTRODUCTION
        ================================================== */}

        <section
          className="home-local-content"
          aria-labelledby="udaipur-rental-title"
        >
          <div className="section">

            <h2 id="udaipur-rental-title">
              Bike, Scooty & Taxi Rental in Udaipur
            </h2>

            <p>
              VK Bike On Rent provides bike, scooty and taxi rental
              options for visitors exploring Udaipur, Rajasthan.
              Whether you need a two-wheeler for sightseeing or
              a taxi for local travel and airport transportation,
              you can contact us to check current availability,
              pricing and booking requirements.
            </p>

            <p>
              Located near Jagdish Chowk, VK Bike On Rent is
              convenient for visitors exploring Udaipur's historic
              areas and popular attractions. Rental availability
              and pricing may vary, so contact us before your trip
              to confirm the vehicle and service you need.
            </p>

          </div>
        </section>

        {/* =================================================
            EXPLORE UDAIPUR
        ================================================== */}

        <section
          className="home-local-content"
          aria-labelledby="explore-udaipur-title"
        >
          <div className="section">

            <h2 id="explore-udaipur-title">
              Explore Udaipur with Flexible Travel Options
            </h2>

            <p>
              Udaipur is known for its lakes, palaces, temples
              and historic streets. Depending on your travel
              requirements, a rental bike, scooty or taxi can
              provide a convenient way to explore the city.
            </p>

            <ul>
              <li>City Palace</li>
              <li>Lake Pichola</li>
              <li>Jagdish Temple</li>
              <li>Fateh Sagar Lake</li>
              <li>Gangaur Ghat</li>
              <li>Saheliyon Ki Bari</li>
            </ul>

          </div>
        </section>

      </main>
    </>
  );
}